export const TRACKING_STATE_STORAGE_NAME = 'trackingState';
